import { GetAllRegionalDoc } from '~/domain/usecases/regionaldoc/remote';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import {
  InvalidCredentialsError,
  UnexpectedError,
  BadRequestError,
  NotFound,
} from '~/domain/errors';

export class RemoteGetAllRegionalDocs implements GetAllRegionalDoc {
  private readonly url: string;

  private readonly httpClient: HttpClient<GetAllRegionalDoc.Model>;

  constructor(url: string, httpClient: HttpClient<GetAllRegionalDoc.Model>) {
    this.url = url;
    this.httpClient = httpClient;
  }

  getAll = async (
    params: GetAllRegionalDoc.Params,
  ): Promise<GetAllRegionalDoc.Model> => {
    let query = '';

    Object.entries(params).forEach(([key, value]) => {
      query += `${key}=${value}&`;
    });

    const httpResponse = await this.httpClient.request({
      url: `${this.url}?${query}`,
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      default:
        throw new UnexpectedError();
    }
  };
}
